(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morsey-klaviyo-popup"]) return;
  try {
    
  (() => {
    const selector = '[data-morsey-klaviyo-popup]';

    const initialize = (popup) => {
      if (!(popup instanceof HTMLElement) || popup.dataset.initialized === 'true') return;
      popup.dataset.initialized = 'true';

      const form = popup.querySelector('[data-morsey-popup-form]');
      const emailInput = popup.querySelector('[data-morsey-popup-email]');
      const submitButton = popup.querySelector('[data-morsey-popup-submit]');
      const message = popup.querySelector('[data-morsey-popup-message]');
      const dialog = popup.querySelector('.morsey-k-popup__dialog');
      const successPanel = popup.querySelector('[data-morsey-popup-success]');
      const closeButtons = popup.querySelectorAll('[data-morsey-popup-close]');
      const storageKey = 'morsey-klaviyo-popup-dismissed';
      const subscribedKey = 'morsey-klaviyo-popup-subscribed';
      let closeTimer;

      const isOpen = () => popup.classList.contains('is-open');

      const open = () => {
        if (isOpen()) return;
        popup.hidden = false;
        popup.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('morsey-k-popup-lock');
        window.requestAnimationFrame(() => popup.classList.add('is-open'));
        window.removeEventListener('scroll', checkScroll);
        window.setTimeout(() => popup.querySelector('.morsey-k-popup__close')?.focus(), 200);
      };

      const rememberDismissal = () => {
        try {
          const frequency = popup.dataset.frequency;
          if (frequency === 'session') sessionStorage.setItem(storageKey, '1');
          if (frequency === '7days' || frequency === '30days') localStorage.setItem(storageKey, String(Date.now()));
        } catch (error) {
          return;
        }
      };

      const close = (remember = true) => {
        if (!isOpen()) return;
        popup.classList.remove('is-open');
        popup.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('morsey-k-popup-lock');
        if (remember) rememberDismissal();
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => {
          if (!isOpen()) popup.hidden = true;
        }, 190);
      };

      const wasDismissed = () => {
        try {
          if (localStorage.getItem(subscribedKey) === '1') return true;
          const frequency = popup.dataset.frequency;
          if (frequency === 'always') return false;
          if (frequency === 'session') return sessionStorage.getItem(storageKey) === '1';
          const savedAt = Number.parseInt(localStorage.getItem(storageKey) || '0', 10);
          const days = frequency === '30days' ? 30 : 7;
          return savedAt > 0 && Date.now() - savedAt < days * 86400000;
        } catch (error) {
          return false;
        }
      };

      function checkScroll() {
        const main = document.querySelector('#MainContent');
        const firstSection = main ? Array.from(main.children).find((element) => element instanceof HTMLElement && element.offsetHeight > 0) : null;
        const percent = Number.parseFloat(popup.dataset.triggerPercent || '90');
        const triggerPoint = firstSection instanceof HTMLElement
          ? firstSection.offsetTop + firstSection.offsetHeight * (percent / 100)
          : window.innerHeight * (percent / 100);
        if (window.scrollY >= triggerPoint) open();
      }

      const showMessage = (text, isError = false) => {
        if (!(message instanceof HTMLElement)) return;
        message.textContent = text;
        message.classList.toggle('is-error', isError);
        message.hidden = false;
      };

      const submit = async (event) => {
        event.preventDefault();
        if (!(emailInput instanceof HTMLInputElement) || !(submitButton instanceof HTMLButtonElement)) return;

        emailInput.setCustomValidity('');
        if (!emailInput.validity.valid) {
          emailInput.reportValidity();
          return;
        }

        const publicKey = popup.dataset.publicKey || '';
        const listId = popup.dataset.listId || '';
        if (!publicKey || !listId) {
          showMessage('Klaviyo is not configured.', true);
          return;
        }

        submitButton.disabled = true;
        submitButton.setAttribute('aria-busy', 'true');
        if (message instanceof HTMLElement) message.hidden = true;

        try {
          const response = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${encodeURIComponent(publicKey)}`, {
            method: 'POST',
            headers: {
              accept: 'application/vnd.api+json',
              'content-type': 'application/vnd.api+json',
              revision: '2026-07-15'
            },
            body: JSON.stringify({
              data: {
                type: 'subscription',
                attributes: {
                  custom_source: 'Morsey homepage video popup',
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: emailInput.value.trim(),
                        subscriptions: {
                          email: {
                            marketing: {
                              consent: 'SUBSCRIBED'
                            }
                          }
                        }
                      }
                    }
                  }
                },
                relationships: {
                  list: {
                    data: {
                      type: 'list',
                      id: listId
                    }
                  }
                }
              }
            })
          });

          if (!response.ok) {
            const payload = await response.json().catch(() => null);
            throw new Error(payload?.errors?.[0]?.detail || 'Unable to subscribe right now.');
          }

          try {
            localStorage.setItem(subscribedKey, '1');
          } catch (error) {
          }

          if (
            dialog instanceof HTMLElement
            && successPanel instanceof HTMLElement
            && successPanel.querySelector('img') instanceof HTMLImageElement
          ) {
            dialog.classList.add('is-success');
            successPanel.hidden = false;
            successPanel.querySelector('[data-morsey-popup-close]')?.focus();
          } else {
            close(true);
          }
        } catch (error) {
          showMessage(error instanceof Error ? error.message : 'Unable to subscribe right now.', true);
        } finally {
          submitButton.disabled = false;
          submitButton.removeAttribute('aria-busy');
        }
      };

      form?.addEventListener('submit', submit);
      closeButtons.forEach((button) => button.addEventListener('click', () => close(true)));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close(true);
      });

      const onSectionSelect = (event) => {
        if (event.detail?.sectionId === popup.dataset.sectionId) open();
      };
      const onSectionDeselect = (event) => {
        if (event.detail?.sectionId === popup.dataset.sectionId) close(false);
      };

      if (popup.dataset.designMode === 'true') {
        document.addEventListener('shopify:section:select', onSectionSelect);
        document.addEventListener('shopify:section:deselect', onSectionDeselect);
        return;
      }

      if (popup.dataset.enabled !== 'true' || wasDismissed()) return;
      window.addEventListener('scroll', checkScroll, { passive: true });
      window.setTimeout(checkScroll, 150);
    };

    const initializeAll = (scope = document) => {
      if (scope instanceof HTMLElement && scope.matches(selector)) initialize(scope);
      scope.querySelectorAll?.(selector).forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initializeAll());
    } else {
      initializeAll();
    }

    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["morsey-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('morsey-arrivals')) {
    customElements.define(
      'morsey-arrivals',
      class MorseyArrivals extends HTMLElement {
        connectedCallback() {
          this.track = this.querySelector('[data-arrivals-track]');
          this.previous = this.querySelector('[data-arrivals-previous]');
          this.next = this.querySelector('[data-arrivals-next]');
          if (!this.track || !this.previous || !this.next) return;

          this.previous.addEventListener('click', () => this.move(-1));
          this.next.addEventListener('click', () => this.move(1));
          this.track.addEventListener('scroll', () => this.update(), { passive: true });
          new ResizeObserver(() => this.update()).observe(this.track);
          this.update();
        }

        move(direction) {
          const card = this.track.querySelector('.morsey-arrivals__card');
          const distance = card ? card.getBoundingClientRect().width : this.track.clientWidth;
          this.track.scrollBy({ left: direction * distance, behavior: 'smooth' });
        }

        update() {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          this.previous.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= maximum - 2;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
